import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';

const styles = theme => ({
  root: {
    width: '100%',
    minHeight: '500px'
  }
});

export default compose(withStyles(styles));



// WEBPACK FOOTER //
// ./src/components/company/discover-influencers/AgeRangeSelector.enhancer.js